import store from "@/store";
import moment from 'moment';
import _ from "lodash";
export default {
  capitalize: (value) => {
    if (!value) return '';
    value = value.toString();
    return value.charAt(0).toUpperCase() + value.slice(1)
  },

  filter: (value, where) => {
    const typea = typeof (where);
    const result = _.filter(value, where);
    // const result = value.filter(function (item, keys) {

    //   if (typea == "string") {
    //     return item.indexOf(where) !== -1;
    //   } else {
    //     console.log(where, item);
    //     const op = _.map(where, (iit, key) => {
    //       return item[key] === iit;
    //     }).filter((ite) => {
    //       return ite;
    //     }).length;
    //     console.log(op);
    //     return op > 0;

    //   }
    // });
    return result;
  },

  changelang: (value, field) => {
    let result = (store.state.Public.publang[field]) ? store.state.Public.publang[field][value] :
      "";
    return result || value;
  },

  currency: (value) => {
    console.log(value);
    let number = "";
    number = value.toString().replace(/^(-?\d+?)((?:\d{3})+)(?=\.\d+$|$)/, function (all, pre,
      groupOf3Digital) {
      return pre + groupOf3Digital.replace(/\d{3}/g, ',$&');
    });
    return "$" + number;
  },

  dateFormat: (value, format, day) => {
    const date = {
      1: "一",
      2: "二",
      3: "三",
      4: "四",
      5: "五",
      6: "六",
      0: "日",
    }

    if (day) {
      const getday = moment(value).format("d");
      const chdate = date[getday];
      return moment(value).format(format) + "(" + chdate + ")";
    } else {
      return moment(value).format(format);
    }
  },

  applyRepeat: (value, number) => {
    let tmp = [];
    let i = 0;
    for (i = 0; i < number; i++) {
      tmp.push(i);
    };
    return tmp;
  },

  orderState: (value) => {
    switch (value) {
      case "nopay":
        return "未付款";
      default:
        return value;
    }
  }
}
